import { IDufusionLoggable } from '@services/strategy-pattern-login/iDifusion-loggable';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class IDifusionWso2Service implements IDufusionLoggable {

  constructor() { }

  updatePassowrd(login: any, oldPassword: any, newPassword: any) {
    throw new Error('Method not implemented.');
  }

}
